var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-progress",style:({height: _vm.height + 'px'})},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('div',{class:['progress', _vm.valueClass],style:({width: _vm.value + '%', height: _vm.height + 'px'}),attrs:{"value":_vm.value,"max":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }